var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirewall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 730.925,
    x2: 3146.175,
    y1: 1415.875,
    y2: 3831.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M3413 1682.7v360.4h-370.4v-360.4zM834.5 3113.2v-444.4H464.1v444.4zm2208.1 0H3413v-444.4h-370.4zM464.1 3564.3h701.1v-360.4H464.1zm2247.8 0H3413v-360.4h-701.1zm-196.1-1972.1c80.6-199.5 42.7-420.1-3-569.6-26.5 135.1-76.7 231.6-87.1 250.7-7 15.3-22.4 26.1-40.4 26.5-25 .4-45.7-19.5-46.2-44.5l.2-.2c-6-310.8-410.2-537.6-308.1-934.7-250.2 180-318.3 424.6-361.1 578.5-30.2 108.5-50.4 181.1-120.4 185.1-30 1.7-58.3-13.7-74.1-39.1-24.2-38.9-49.7-90.5-70.1-134.7-96.8 224-136.5 467.6-17.6 681.8 25.7 0 1051.1 0 1127.9.2zM1564 3203.9h-308v360.4h637.3v-130.6h-.1c-97-62.7-205.4-114-329.2-229.8zm732.7 0c-90.2 81.4-195.6 156.8-312.8 229.6v130.8h637.3v-360.4zm655.2-90.7v-444.4h-331.6c-33.3 171.8-115.2 316.7-232 444.4zm-331.5-816.1c16.7 101 20.5 194.3 12.7 281.1H3413v-444.4h-833.7c17.8 56.5 32.6 112 41.1 163.3zm-71.6-254h403.1v-360.4h-615.1V1837l62.8-35.4c24.5-17.3 58.9-6.4 68.9 22h-.1c25.4 72.1 52.6 141.1 80.4 219.5zm-452.6-70.3 150-84.7v-205.5H1631v205.6c73.2 41.3 143.5 81.2 150.2 84.6l132-74.9c13.8-9.3 32.3-10.6 47.7-1.9v.1zm-765 70.3c26.9-83 44.3-125.5 76.6-216.9 8.1-28.3 40.4-41.4 65.9-27.1l-.1.2 66.7 37.7v-154.3H925.2v360.4zm-27.6 90.7H464.1v444.4h784.8c-11.3-144.4 11.6-291.3 54.7-444.4zm-378.4 535v444.4h552.3c-20.4-24-186.6-278.4-216.9-444.4zm1605.9-357.3c-9.8-59.3-29.3-126.4-52.3-194.3-11.6-14-10.3-29.7-10.3-30.1-21.4-61.2-44.5-121.8-67.2-183-283.1 159.8-272 154.5-282.8 157.5-7.3 2.4-15.1 4-23 4-11 0-29.4-5-37.3-10.3l-119.8-67.9-122.8 69.6v.1c-24 13.9-58.5 9-81.2-6.8-8.8-5-250.8-141.6-258.5-146-82.1 226.2-163.9 461.8-132.4 706.5 3.3 11.4 19.2 267.3 260.5 506.3 9.7 4.3 17.5 11.9 22.2 21.3 114.8 107 215.8 154.7 312.2 216.8 423-263.5 674.1-550.1 592.7-1043.7zm-562.8 835.2c-16 9.8-35.7 8.5-50.1-1.8-16.2-15.5-449.2-214.5-438-713.9 2.8-125.4 27.5-192.7 67.8-307h-.1c10-28.3 44.3-39.3 68.9-22l84.3 47.6c86 48.6 143.3 25.5 221.2-18.6v-.1c15.5-8.8 33.9-7.4 47.7 1.9 138.5 78.5 174.2 41.7 306.3-32.9l-.1-.2c25.6-14.4 57.9-1.1 65.9 27.1 39.9 113.2 64.1 180.2 66.9 304.4 2.6 116.7-19.9 232.4-70.6 339.4-109.3 231.3-301.4 330.2-370.2 376zm-1133.8-1464H464.1v360.4h370.4zm1484.2 750c-2-89-16.4-146.9-45-227.9-102.3 57.8-197.1 92.3-309.5 28.5l-19.6-11.1-19.6 11.1c-84.2 47.8-185.3 41.7-268.1-5.1l-41.4-23.4c-28.6 81-43 138.9-45 227.9-9.7 433.4 362.9 611.1 374.1 622.3 12.9-8.7 91.7-51.2 170.7-127.8 138.2-134 207.6-306.3 203.4-494.5zm-144.2 70-279.2 279.2c-17.7 17.7-46.4 17.7-64.1 0l-107.4-107.4c-17.7-17.7-17.7-46.4 0-64.1 17.8-17.7 46.5-17.7 64.2 0l75.3 75.3 247.1-247.1c17.7-17.7 46.4-17.7 64.1 0s17.7 46.4 0 64.1z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewall);
export default __webpack_public_path__ + "static/media/firewall.5abbaf975dcf26885dd114bfad224867.svg";
export { ForwardRef as ReactComponent };